import { LocaleListExternal, LocaleListInternal, LocaleListItem } from "./types";

const sortLocales = (a: LocaleListItem, b: LocaleListItem): -1 | 0 | 1 =>
  a.name > b.name ? 1 : b.name > a.name ? -1 : 0;

export const internalLocales: LocaleListInternal = [
  {
    locale: "en_US",
    name: "English",
    flagName: "us",
    bcp47Locale: "en-US",
    iso6391: "en",
    drupal: "en-us",
  },
  {
    locale: "de",
    name: "Deutsch",
    flagName: "de",
    bcp47Locale: "de",
    iso6391: "de",
    drupal: "de",
  },
  {
    locale: "hr",
    name: "Hrvatski",
    flagName: "hr",
    bcp47Locale: "hr",
    iso6391: "hr",
    drupal: "hr",
  },
  {
    locale: "fr",
    name: "Français",
    flagName: "fr",
    bcp47Locale: "fr",
    iso6391: "fr",
    drupal: "fr",
  },
  {
    locale: "it",
    name: "Italiano",
    flagName: "it",
    bcp47Locale: "it",
    iso6391: "it",
    drupal: "it",
  },
  {
    locale: "lv_LV",
    name: "Latviešu",
    flagName: "lv",
    bcp47Locale: "lv",
    iso6391: "lv",
    drupal: "lv",
  },
  {
    locale: "pl",
    name: "Polski",
    flagName: "pl",
    bcp47Locale: "pl",
    iso6391: "pl",
    drupal: "pl",
  },
  {
    locale: "pt_PT",
    name: "Português",
    flagName: "pt",
    bcp47Locale: "pt",
    iso6391: "pt",
    drupal: "pt-pt",
  },
  {
    locale: "pt_BR",
    name: "Português (Brasil)",
    flagName: "br",
    bcp47Locale: "pt-BR",
    iso6391: "pt",
    drupal: "pt-br",
  },
  {
    locale: "es",
    name: "Español",
    flagName: "es",
    bcp47Locale: "es",
    iso6391: "es",
    drupal: "es",
  },
  {
    locale: "uk",
    name: "Українська",
    flagName: "ua",
    bcp47Locale: "uk",
    iso6391: "uk",
    drupal: "uk",
  },
  {
    locale: "tr",
    name: "Türk",
    flagName: "tr",
    bcp47Locale: "tr",
    iso6391: "tr",
    drupal: "tr",
  },
];

export const defaultExternalLocale: Required<LocaleListItem> = {
  locale: "en",
  name: "English",
  flagName: "eu",
  bcp47Locale: "en",
  iso6391: "en",
  drupal: "en-gl",
};

export const externalLocales: LocaleListExternal = [
  defaultExternalLocale,
  {
    locale: "at",
    name: "Deutsch",
    flagName: "at",
    bcp47Locale: "de-AT",
    iso6391: "de",
    drupal: "de-at",
  },
  {
    locale: "bg",
    name: "Български",
    flagName: "bg",
    bcp47Locale: "bg",
    iso6391: "bg",
    drupal: "bg",
  },
  {
    locale: "bs",
    name: "Bosanski",
    flagName: "ba",
    bcp47Locale: "bs",
    iso6391: "bs",
    drupal: "bs",
  },
  {
    locale: "ca",
    name: "Català",
    flagName: "es-ct",
    bcp47Locale: "ca",
    iso6391: "ca",
    drupal: "ca",
  },
  {
    locale: "cs",
    name: "Čeština",
    flagName: "cz",
    bcp47Locale: "cs",
    iso6391: "cs",
    drupal: "cs",
  },
  {
    locale: "da",
    name: "Dansk",
    flagName: "dk",
    bcp47Locale: "da",
    iso6391: "da",
    drupal: "da",
  },
  {
    locale: "de",
    name: "Deutsch",
    flagName: "de",
    bcp47Locale: "de",
    iso6391: "de",
    drupal: "de",
  },
  {
    locale: "de_CH",
    name: "Deutsch",
    flagName: "ch",
    bcp47Locale: "de-CH",
    iso6391: "de",
    drupal: "de-ch",
  },
  {
    locale: "el",
    name: "Ελληνικά",
    flagName: "gr",
    bcp47Locale: "el-GR",
    iso6391: "el",
    drupal: "el",
  },
  {
    locale: "en_CA",
    name: "English",
    flagName: "ca",
    bcp47Locale: "en-CA",
    iso6391: "en",
    drupal: "en-ca",
  },
  {
    locale: "en_GB",
    name: "English",
    flagName: "gb",
    bcp47Locale: "en-GB",
    iso6391: "en",
    drupal: "en-gb",
  },
  {
    locale: "en_IE",
    name: "English",
    flagName: "ie",
    bcp47Locale: "en-IE",
    iso6391: "en",
    drupal: "en-ie",
  },
  {
    locale: "en_IN",
    name: "English",
    flagName: "in",
    bcp47Locale: "en-IN",
    iso6391: "en",
    drupal: "en-in",
  },
  {
    locale: "en_US",
    name: "English",
    flagName: "us",
    bcp47Locale: "en-US",
    iso6391: "en",
    drupal: "en-us",
  },
  {
    locale: "es",
    name: "Español",
    flagName: "es",
    bcp47Locale: "es",
    iso6391: "es",
    drupal: "es",
  },
  {
    locale: "es_CL",
    name: "Español",
    flagName: "cl",
    bcp47Locale: "es-CL",
    iso6391: "es",
    drupal: "es-cl",
  },
  {
    locale: "es_MX",
    name: "Español",
    flagName: "mx",
    bcp47Locale: "es-MX",
    iso6391: "es",
    drupal: "es-mx",
  },
  {
    locale: "es_US",
    name: "Español",
    flagName: "us",
    bcp47Locale: "es-US",
    iso6391: "es",
    drupal: "es-us",
  },
  {
    locale: "et_EE",
    name: "Estonian",
    flagName: "ee",
    bcp47Locale: "et",
    iso6391: "et",
    drupal: "et",
  },
  {
    locale: "fi",
    name: "Suomi",
    flagName: "fi",
    bcp47Locale: "fi-FI",
    iso6391: "fi",
    drupal: "fi",
  },
  {
    locale: "fr",
    name: "Français",
    flagName: "fr",
    bcp47Locale: "fr",
    iso6391: "fr",
    drupal: "fr",
  },
  {
    locale: "fr_BE",
    name: "Français",
    flagName: "be",
    bcp47Locale: "fr-BE",
    iso6391: "fr",
    drupal: "fr-be",
  },
  {
    locale: "fr_CA",
    name: "Français",
    flagName: "ca",
    bcp47Locale: "fr-CA",
    iso6391: "fr",
    drupal: "fr-ca",
  },
  {
    locale: "fr_CH",
    name: "Français",
    flagName: "ch",
    bcp47Locale: "fr-CH",
    iso6391: "fr",
    drupal: "fr-ch",
  },
  {
    locale: "hr",
    name: "Hrvatski",
    flagName: "hr",
    bcp47Locale: "hr",
    iso6391: "hr",
    drupal: "hr",
  },
  {
    locale: "hu",
    name: "Magyar",
    flagName: "hu",
    bcp47Locale: "hu",
    iso6391: "hu",
    drupal: "hu",
  },
  {
    locale: "it",
    name: "Italiano",
    flagName: "it",
    bcp47Locale: "it",
    iso6391: "it",
    drupal: "it",
  },
  {
    locale: "it_CH",
    name: "Italiano",
    flagName: "ch",
    bcp47Locale: "it-CH",
    iso6391: "it",
    drupal: "it-ch",
  },
  {
    locale: "lt_LT",
    name: "Lietuvių",
    flagName: "lt",
    bcp47Locale: "lt",
    iso6391: "lt",
    drupal: "lt",
  },
  {
    locale: "lv_LV",
    name: "Latviešu",
    flagName: "lv",
    bcp47Locale: "lv",
    iso6391: "lv",
    drupal: "lv",
  },
  {
    locale: "mk",
    name: "Македонски",
    flagName: "mk",
    bcp47Locale: "mk",
    iso6391: "mk",
    drupal: "mk",
  },
  {
    locale: "nl",
    name: "Nederlands",
    flagName: "nl",
    bcp47Locale: "nl",
    iso6391: "nl",
    drupal: "nl",
  },
  {
    locale: "nl_BE",
    name: "Nederlands",
    flagName: "be",
    bcp47Locale: "nl-BE",
    iso6391: "nl",
    drupal: "nl-be",
  },
  {
    locale: "no",
    name: "Norsk (bokmål)",
    flagName: "no",
    bcp47Locale: "nb",
    iso6391: "nb",
    drupal: "nb",
  },
  {
    locale: "pl",
    name: "Polski",
    flagName: "pl",
    bcp47Locale: "pl",
    iso6391: "pl",
    drupal: "pl",
  },
  {
    locale: "pt",
    name: "Português",
    flagName: "pt",
    bcp47Locale: "pt",
    iso6391: "pt",
    drupal: "pt-pt",
  },
  {
    locale: "pt_BR",
    name: "Português",
    flagName: "br",
    bcp47Locale: "pt-BR",
    iso6391: "pt",
    drupal: "pt-br",
  },
  {
    locale: "ro",
    name: "Română",
    flagName: "ro",
    bcp47Locale: "ro",
    iso6391: "ro",
    drupal: "ro",
  },
  {
    locale: "sk",
    name: "Slovenčina",
    flagName: "sk",
    bcp47Locale: "sk",
    iso6391: "sk",
    drupal: "sk",
  },
  {
    locale: "sl",
    name: "Slovenščina",
    flagName: "si",
    bcp47Locale: "sl",
    iso6391: "sl",
    drupal: "sl",
  },
  {
    locale: "sq",
    name: "Shqip",
    flagName: "al",
    bcp47Locale: "sq",
    iso6391: "sq",
    drupal: "sq",
  },
  {
    locale: "sr_Latn_RS",
    name: "Srpski",
    flagName: "rs",
    bcp47Locale: "sr",
    iso6391: "sr",
    drupal: "sr",
  },
  {
    locale: "sv",
    name: "Svenska",
    flagName: "se",
    bcp47Locale: "sv",
    iso6391: "sv",
    drupal: "sv",
  },
  {
    locale: "tr",
    name: "Türkçe",
    flagName: "tr",
    bcp47Locale: "tr",
    iso6391: "tr",
    drupal: "tr",
  },
  {
    locale: "uk",
    name: "Українська",
    flagName: "ua",
    bcp47Locale: "uk",
    iso6391: "uk",
    drupal: "uk",
  },
  {
    locale: "zh_US",
    name: "中文",
    flagName: "us",
    bcp47Locale: "zh",
    iso6391: "zh",
    drupal: "zh-us",
  },
].sort(sortLocales);

export const getLanguageObjectBasedOnLocale = (locale: string, isInternal: boolean): LocaleListItem => {
  let currentLanguage;

  if (isInternal) {
    currentLanguage = internalLocales.find((l) => l.locale === locale);
  } else {
    let localeMappedToPhrase = locale;
    if (locale === "pt_PT") {
      localeMappedToPhrase = "pt";
    }

    currentLanguage = externalLocales.find((l) => l.locale === localeMappedToPhrase);
  }

  return currentLanguage || defaultExternalLocale;
};
